import * as React from 'react';

import {colors} from '../colors/colors';
import type {ColorName} from '../colors/colors';

import styles from './field-with-icon.module.css';

type Props = {
    icon: React.ComponentType<any>;
    iconColor?: ColorName;
    // Expected to work with all our standard text based input fields
    children: React.ReactElement<any>;
};

export function FieldWithIcon(props: Props) {
    const {icon: Icon, children, iconColor = 'grey'} = props;
    // Small and big sizes are 31px and 51px - normal is 34px. For odd numbered sizes, icons do not line up
    // correctly and need a 1px bottom padding offset
    const child = React.Children.only(children);
    const iconNeedsOffset = child.props.size === 'small' || child.props.size === 'big';

    return (
        <div className={styles['field-with-icon']}>
            <div className={iconNeedsOffset ? styles['icon--with-offset'] : styles.icon}>
                <Icon
                    wrapWithDiv={false}
                    size={15}
                    color={colors[iconColor]}
                    fill={colors[iconColor]}
                />
            </div>
            {children}
        </div>
    );
}
